import angular from 'angular';

(function() {
  'use strict';
  angular.module('app.core').factory('UserAssignments', UserAssignmentsData);

  UserAssignmentsData.$inject = [];

  /* @ngInject */
  function UserAssignmentsData() {
    UserAssignments.prototype = { setProfil: setProfil };

    function UserAssignments(profil) {
      this.profil = profil;
    }

    return UserAssignments;

    /////////////////////

    function setProfil(profil) {
      this.profil = profil;
    }
  }
})();
